export default "__VITE_ASSET__BuZaetga__"